module.exports = __webpack_public_path__ + "static/img/team2.59d068b3.svg";